import enMessages from './lang/en';
import ptMessages from './lang/pt';

export const langRefs = { 'en-US': enMessages, 'pt-BR': ptMessages };
